import { useState } from "react"
import ContactSalesModal from "components/ContactSalesModal"
import { usePageAssets } from "hooks/usePageAssets"
import { openModal } from "utils/openModal"
import Button from "components/ui/Button"
import Heading from "components/ui/Heading"
import SplitContainer from "components/ui/Layout/SplitContainer"

function HeroSection() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  const { getAsset } = usePageAssets()
  const illustration = getAsset("api-hero-illustration-svg")
  return (
    <section className="relative z-10 pb-10 pt-24 lg:pb-32 lg:pt-48">
      <SplitContainer
        image={illustration}
        imageSize="large"
        imageClassName="mt-12 lg:mt-0 lg:-mr-32 xl:-mr-10"
      >
        <Heading
          level="h1"
          title="Manage your Superset instances with the Preset API"
          subtitle={
            <>
              Many of Preset’s user interface interactions are available via the
              Preset API, enabling DevOps, engineers, and data teams to manage
              user access, workspaces, and assets as code.
            </>
          }
          size="huge"
          inverted
        />
        <Button
          className="mt-7"
          color="green"
          size="medium"
          href="/contact-sales/"
          onClick={openModal(setIsContactModalOpen)}
          trackClick="Request Access (hero)_API"
          inverted
        >
          Request Access
        </Button>
      </SplitContainer>
      <ContactSalesModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        sourcePage="API - Hero"
      />
    </section>
  )
}

export default HeroSection
